import styled from 'styled-components';

export default styled.div`
  background-color: #FFF;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
